import { NavTopQuizComponent } from "../components/navQuiz/NavTopQuiz.component";
import { NavBtnQuizComponent } from "../components/navBtnQuiz/NavBtnQuiz.component";
import { device } from "~/js/tools/device";
import { TYPE_4_OPTIONS, FIELD_RADIUS, FIELD_SIZE, FORM_STYLE } from "~/js/configs/qform-options";
import { JSEncrypt } from "jsencrypt";
import { reachVkGoal } from "../core/vkPixel.js";
const QUIZ_DEFAULT_DISPLAY_TYPE = 0;
const QUIZ_IN_WINDOW_DISPLAY_TYPE = 1;
export class Quiz {
  constructor(selector, settings) {
    this.selector = selector;
    this.TYPE_COMPONENTS = {};
    this.sendFlag = false;
    this.settings = settings;
    this.allStyle = settings.data.style || null;
    this.allOptions = settings.data.options || null;
    this.agreementSettings = settings.data.agreement || null;
    this.isAdviseCheckboxChecked = 0;
    this.components = {
      [settings.data.firstBlockId]: []
      /* blockId: settings.data.firstBlockId,
      blockType: 1, */
    };

    this.hiddenComponents = {};
    this.fields = settings.data.fields;
    this.data = settings.data;
    this.id = settings.data.formID;
    this.quizWrapperId = `${this.id}_quiz-wrapper`;
    this.currentBlockId = settings.data.firstBlockId;
    this.currentBlockOrder = 0;
    //добавление первого шага в масиив блоков
    this.blockIds = [];
    this.blockIds[this.currentBlockOrder] = {
      id: settings.data.firstBlockId,
      order: this.currentBlockOrder
    };
    this.typeBlocks = {
      [settings.data.firstBlockId]: 1
    };
    this.stepCount = settings.data.blockQuantity;
    this.blocksWidgetsIds = {};
    this.completeBlockIds = [];
    this.publicKey = settings.options.publicKey;
    this.mode = settings.options.mode;
    this.domain = settings.options.domain;
    this.options = {
      ...settings.options,
      ...this.settings
    };
    this.options.uploadActive = settings.data.uploadActive;
    this.options.formStyle = settings.data.formStyle || false;
    this.options.messages = settings.data.messages || false;
    this.btnModalComponent = null;
    this.BtnModalComponent = null;
    this.options.openButton = settings.data.openButton || false;
    this.options.buttonText = settings.data.buttonText;
    this.options.buttonHoverStyle = settings.data.buttonHoverStyle || 0;
    this.messages = settings.data.messages;
    this.quizBlocks = [];
    // ["0: Шаги || 1: ПрогрессБар", "0: Горизонтально || 1: Вертикально"]
    this.blockNavStyle = ["0", "0"]; /* settings.data.blockNavStyle ? settings.data.blockNavStyle.split(".") : ["1", "0"]; */
    this.navVertical = this.blockNavStyle[1] || "1";
    this.blockTitle = {
      [settings.data.firstBlockId]: settings.data.blockTitle || ""
    };
    this.quizDisplayType = settings.data.displayType; // 0 - в контенте, 1 - в модальном окне
    this.options.formId = settings.data.formID;
    this.options.agreementLabelEx = settings.data.labelEx || "";
    this.useRecaptcha = settings.data.useRecaptcha;
    this.captchaSitekey = settings.data.captchaSitekey;
    this.recaptchaVersion = settings.data.recaptchaVersion;
    this.recaptchaMode = settings.data.recaptchaMode;
    this.fieldStyle = false;
    this.fontCssRule = null;
    this.useDesign = settings.data.useDesign;
    this.device = settings.device;
    this.startTime = parseInt(new Date().getTime());
    this.emiterGlob = settings.emiterGlob;
    this.emitterStatistics = settings.emitterStatistics;
    this.emitterStatistics.emit(`${this.id}:timesTamp`, {
      id: this.id
    });
    this.emitterStatistics.emit(`${this.id}:siteId`, {
      id: this.id,
      site_id: settings.data.siteId
    });
    this.emitterStatistics.emit(`${this.id}:uid`, {
      id: this.id,
      uid: settings.data.uid
    });
    this.emitterFormWidget = settings.emitterFormWidget;
    this.Proxy = settings.options.proxy_module;
    //остаток функционала от квиза в виджете
    this.EmitterChangeStep = settings.extraSettings ? settings.extraSettings.EmitterChangeStep || null : null;
    this.navTop = null;
    this.navBtn = null;
    this.firstBlockId = settings.data.firstBlockId;
    this.countInitComponents = 0; // Счетчик инициализированых компонентов
    //настройки картинки для квиза
    this.quizPictureSrc = settings.data.img_src;
    this.quizPicturePosition = settings.data.img_position;
    this.quizPictureShowOnMobile = settings.data.img_show_on_mobile;
    //настройки изображений для шагов квиза
    this.quizPicturesData = {};
    this.saveQuizPictureData(this.currentBlockId);
  }

  //сохранение настроек для изображения квиза на случай повторного переключения на текущую вкладку
  saveQuizPictureData(blockId) {
    this.quizPicturesData[blockId] = {
      quizPictureSrc: this.quizPictureSrc,
      quizPicturePosition: this.quizPicturePosition,
      quizPictureShowOnMobile: this.quizPictureShowOnMobile
    };
  }
  async getRoot() {
    let styleForm = ["qform", "qform-default", "qform-size-md", "qform-placeholder_show", "qform-radius-5px", "qform-label_inside_show", "qform-icon_inside_left", "qform-hint_outside-left", "qform-valid_light", "qform-error_light"];
    this.$form = this.$.create("form", styleForm);

    // отрисовка кнопки "далее" для перехода на следующий шаг квиза
    this.$navBtn = this.$.create("div", "qform-row");
    this.navBtn = new NavBtnQuizComponent(this.$navBtn, {
      tabNum: 0,
      formIndex: this.options.formIndex,
      formId: this.options.formId,
      Emitter: this.Emitter,
      useDesign: this.useDesign,
      submitSetting: this.data.submitButton,
      mode: this.mode,
      messages: this.messages,
      showCaption: this.data.showCaption,
      captionLink: this.data.linkCreate
    });
    this.navBtn.toHTML();
    this.navBtn.init();

    //отрисовка форм в одну или несколько колонок в зависимости от настроек
    this.rows = [];
    this.components[this.blockIds[0].id] = this.components[this.blockIds[0].id].map(x => {
      let $el;
      let isNewRow = false;
      if (x.options.row) {
        if (!this.rows.find(row => row.id === x.options.row)) {
          const newRow = {
            id: x.options.row,
            $el: this.$.create("div", "qform-row"),
            elementsCount: 1
          };
          this.rows.push(newRow);
          $el = newRow.$el;
          isNewRow = true;
        } else {
          const row = this.rows.find(row => row.id === x.options.row);
          $el = row.$el;
          row.elementsCount++;
          isNewRow = false;
        }
      } else {
        $el = this.$.create("div", "qform-row");
        isNewRow = true;
        this.rows.push({
          id: `single_row_${this.rows.length}`,
          $el
        });
      }
      x.Component = new x.Component($el, x.options, this.selector.getAttribute("data-q-form-index")); // x.Component.then(component => {return new component($el, x.options)})//  new x.Component($el, x.options);
      const component = x.Component;
      $el.$el.insertAdjacentHTML("beforeend", component.toHTML());
      if (isNewRow) {
        this.$form.append($el);
      }
      return component;
    });

    //добавление кнопки "далее" к форме
    this.$form.append(this.$navBtn);
    return this.$form;
  }
  createModal($form) {
    const $root = this.$.create("div");
    const $overlay = this.$.create("div", ["form-overlay", "hidden"]);
    const $modal = this.$.create("div", ["form-modal", `qform-theme-${this.allStyle.formStyleCommon.theme ? "black" : "white"}`]);
    this.$modal = $modal;
    if (this.formWidth > 0) {
      $modal.$el.classList.add("qform_modal-adaptive");
    }
    $overlay.id(`modal_${this.options.formId}_${this.options.formIndex}`);
    $modal.append(this.getModalCloseBtn());
    $modal.append($form);
    $overlay.append($modal);
    //записываем элемент формы в модальном окне для простоты доступа для изменения ширины формы
    this.$modalForm = $form;
    this.$modalOverlay = $overlay;
    $root.append(this.createModalButton());
    $root.append($overlay);
    return $root;
  }
  getModalCloseBtn() {
    const $btnClose = this.$.create("div", ["form-modal__close-btn"]);
    $btnClose.id(`modal_${this.options.formId}_${this.options.formIndex}_btn-close`);
    return $btnClose;
  }
  createModalButton() {
    this.$btnModal = this.$.create("div", "btn_modal-box");
    this.$btnModal.id(`btn_modal-box_${this.options.formId}_${this.options.formIndex}`);
    this.btnModalComponent = new this.BtnModalComponent(this.$btnModal, {
      Emitter: this.Emitter,
      // formPicturePosition: this.formPicturePosition,
      formType: "quiz",
      ...this.options
    });
    this.$btnModal.html(this.btnModalComponent.toHTML());
    this.Emitter.subscribe("setQuizPictureHeight", () => this.setQuizPictureHeight());
    this.Emitter.subscribe("openModal", () => {
      if (this.widgetId) {
        try {
          if (!window.players[this.widgetId].isDisposed()) {
            window.players[this.widgetId].dispose();
          }
        } catch (e) {

        } finally {
          this.showWidget();
        }
      }
    });
    this.Emitter.subscribe("closeModal", () => {
      const $widgetsWrapper = document.querySelector(".qform__freewidgets-wrapper");
      $widgetsWrapper?.classList.remove("qform__high-zindex");
      if (this.widgetId) {
        if (!window.players[this.widgetId].isDisposed()) {
          window.players[this.widgetId].dispose();
          document.querySelector(`.qform__freewidgets-wrapper [data-widget=${this.widgetId}]`)?.remove();
        }
      }
    });
    return this.$btnModal;
  }
  getTabnav() {
    this.$navHere = this.$.create("div");
    this.navTop = new NavTopQuizComponent(this.$navHere, {
      blockQuantity: this.data.blockQuantity,
      formIndex: this.options.formIndex,
      formId: this.options.formId,
      quizWrapperId: this.quizWrapperId,
      Emitter: this.Emitter,
      blockNavStyle: this.blockNavStyle,
      blockTitle: this.settings.data.blockTitle,
      messages: this.messages,
      useDesign: this.useDesign
    });
    this.$navHere.html(this.navTop.toHTML());
    return this.$navHere.$el;
  }
  addQuizPicture() {
    const imgPositions = ["right", "left", "top", "bottom", "background"];
    const img_position = imgPositions[this.quizPicturePosition - 1];
    //выбираем главный элемент для изображения шага квиза
    const $rootEl = this.quizDisplayType === 0 ? this.$el : this.$modal;
    //по дефолту очищаем фоновое изображение независимо от его наличия
    this.preventClearQuizBg();
    if (this.quizPictureSrc || this.$picture) {
      if (img_position !== "background") {
        //если контейнер для изображения еще не добавлялся
        if (!this.$picture) {
          if (this.quizPictureSrc) {
            if (this.device !== "mobile" || this.device === "mobile" && this.quizPictureShowOnMobile) {
              this.$picture = this.$.create("div", ["is_qform-picture-container"]);
              $rootEl.$el.classList.add("qform__form-with-picture", `qform__form-picture-${img_position}`);
              this.$picture.$el.style["background-image"] = `url(${this.quizPictureSrc})`;
              $rootEl.$el.prepend(this.$picture.$el);
            }
          }
        } else {
          //удаляем класс расоположения предыдущего изображения
          const classToRemove = [...$rootEl.$el.classList].find(elem => elem.includes("qform__form-picture"));
          $rootEl.$el.classList.remove(classToRemove);
          if (this.device !== "mobile" || this.device === "mobile" && this.quizPictureShowOnMobile) {
            //если есть путь для новой картинки
            if (this.quizPictureSrc) {
              $rootEl.$el.classList.add(`qform__form-picture-${img_position}`);
            }
            this.$picture.$el.style["background-image"] = `url(${this.quizPictureSrc})`;
          }
        }
      } else {
        //удаляем класс расоположения предыдущего изображения
        const classToRemove = [...$rootEl.$el.classList].find(elem => elem.includes("qform__form-picture"));
        $rootEl.$el.classList.remove(classToRemove);
        this.preventClearQuizBg();
        if (this.device !== "mobile" || this.device === "mobile" && this.quizPictureShowOnMobile) {
          $rootEl.$el.classList.add("qform__form-with-bg-picture");
          $rootEl.$el.style["background-image"] = `url(${this.quizPictureSrc})`;
        }
      }
    }
  }
  setQuizPictureHeight() {
    const imgPositions = ["right", "left", "top", "bottom", "background"];
    const img_position = imgPositions[this.quizPicturePosition - 1];
    if (this.quizPictureSrc || this.$picture) {
      if (img_position !== "background") {
        if (img_position === "left" || img_position === "right") {
          //устанавливаем высоту, равную высоте формы (ограничена 50vh)
          if (this.$picture) {
            this.$picture.$el.style.height = this.$quizFormWrapper.$el.clientHeight + "px";
          }
        } else {
          //устанавливаем высоту, равную высоте формы (ограничена 50vh)
          if (this.$picture) {
            this.$picture.$el.style.height = this.$quizFormWrapper.$el.clientHeight + "px";
          }
        }
      } else {
        if (this.$picture) {
          this.$picture.$el.style.height = "0px";
        }
      }
      this.Emitter.emit("pictureData", {
        quizPicture: this.quizPictureSrc,
        quizPicturePosition: img_position
      });
    }
  }
  preventClearQuizBg() {
    //выбираем главный элемент для изображения шага квиза
    const $rootEl = this.quizDisplayType === 0 ? this.$el : this.$modal;
    $rootEl.$el.classList.remove("qform__form-with-bg-picture");
    $rootEl.$el.style["background-image"] = "";
  }
  async getComponent(blockId) {
    let lastBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.components[blockId] = [];
    this.arrComponetsOptions = [];
    const arrFieldId = [];
    this.fields.forEach(field => {
      arrFieldId.push(field.typeId);
    });
    this.TYPE_COMPONENTS = await this.getInstanceComponent(arrFieldId);
    this.fields.forEach((field, index) => {
      if (TYPE_4_OPTIONS[field.typeId]) {
        this.arrComponetsOptions.push({
          id: field.id,
          typeId: field.typeId
        });
      }
      if (this.TYPE_COMPONENTS[field.typeId]) {
        this.components[blockId].push({
          Component: this.TYPE_COMPONENTS[field.typeId],
          options: {
            ...field,
            ...this.options,
            allStyle: this.allStyle,
            Emitter: this.Emitter,
            useDesign: this.useDesign,
            formDisplayType: this.data.displayType
          }
        });
        if (index === this.fields.length - 1 && lastBlock) {
          this.addSubmitBlock(blockId);
        }
      }
    });
    if (!this.fields.length && lastBlock) {
      this.addSubmitBlock(blockId);
    }
  }
  addSubmitBlock(blockId) {
    if (this.useRecaptcha) {
      this.components[blockId].push({
        Component: this.TYPE_COMPONENTS.CaptchaComponent,
        // CaptchaComponent,
        options: {
          formIndex: this.options.formIndex,
          formId: this.options.formId,
          messages: this.options.messages,
          captchaSitekey: this.captchaSitekey,
          domain: this.options.domain,
          recaptchaVersion: this.recaptchaVersion || 2,
          recaptchaMode: this.recaptchaMode,
          server_host: this.options.server_host,
          agreement_controller: this.options.agreement_controller,
          Emitter: this.Emitter
        }
      });
    }
    // добавляю AgreementComponent
    this.components[blockId].push({
      Component: this.TYPE_COMPONENTS[14],
      // AgreementComponent,
      options: {
        formIndex: this.options.formIndex,
        formId: this.options.formId,
        messages: this.options.messages,
        agreementLabelEx: this.options.agreementLabelEx,
        submitSetting: this.data.submitButton,
        captchaSitekey: this.captchaSitekey,
        mode: this.mode,
        domain: this.options.domain,
        recaptchaVersion: this.recaptchaVersion || 2,
        recaptchaMode: this.recaptchaMode,
        server_host: this.options.server_host,
        agreement_controller: this.options.agreement_controller,
        agreementSettings: this.agreementSettings,
        Emitter: this.Emitter,
        useDesign: this.useDesign,
        hideSubmitButton: true,
        styles: this.allStyle,
        device: this.device,
        showCaption: this.data.showCaption,
        isQuiz: true
      }
    });
  }
  setRootMessage(data) {
    this[this.quizDisplayType === QUIZ_DEFAULT_DISPLAY_TYPE ? "$el" : "$modal"].$el.innerHTML = `
      <div class="${this.useDesign ? data.error ? "qform__error-send-msg" : "qform__success-send-msg" : ""}" 
      style="
        font-family: ${this.fontCssRule || "inherit"};
        ${this.allStyle.formStyleCommon.theme ? "color: #fff;" : ""}
        ${this.formWidth ? `width: ${this.formWidth + "px"}` : ""}
     ">

        <div class="message_from_server" style="${this.allStyle.formStyleCommon.theme ? "background: #4E4A4A;" : ""}">
            <p>
                ${data.success || data.error}
            </p>
        </div>

     </div> <!-- вывод ответа от сервера для пользователя-->
    `;
    if (this.quizDisplayType === QUIZ_IN_WINDOW_DISPLAY_TYPE) {
      this.$modal.append(this.getModalCloseBtn());
      this.btnModalComponent.initModalCloseBtn();
    }
  }
  setMassageSend(data) {
    this.setRootMessage(data);
    if (data.javascript) {
      if (data.javascript.extra) {
        try {
          eval(data.javascript.extra);
        } catch (e) {
          console.error("Ошибка в коде Javascript-события", e);
        }
      }
      if (typeof ym === "function" && data.javascript.yaCounter && data.javascript.yaTarget) {
        try {
          ym(+data.javascript.yaCounter, "reachGoal", data.javascript.yaTarget);
        } catch (e) {
          console.error("Yandex metrika is not connected or connection is incorrect", e);
        }
      } else {
        if (data.javascript.yaCounter && data.javascript.yaTarget) {
          try {
            window[`yaCounter${+data.javascript.yaCounter}`].reachGoal(data.javascript.yaTarget);
          } catch (e) {
            console.error("Yandex metrika is not connected or connection is incorrect");
          }
        }
      }
      if (typeof gtag === "function" && data.javascript.gaAction && data.javascript.gaLabel) {
        try {
          gtag("event", data.javascript.gaAction, {
            formName: data.javascript.gaLabel,
            formURL: window.location.host
          });
        } catch (e) {
          console.error("Google Analytics is not connected or connection is incorrect", e);
        }
      }
      reachVkGoal(data);
    }
  }
  getResponse(data) {
    this.Emitter.emit("Submit:disabledBtn", false);
    this.Emitter.emit("Submit:loading", false);
    if (data && data.success) {
      this.setMassageSend(data);
      this.preventClearQuizBg();
      this.emitterFormWidget.emit(`${this.data.id}_block_sent_build`);
      this.dispatchCustomEvent("send");
      //показываем виджет, если он указан
      if (data.videowidgetId) {
        this.widgetId = data.videowidgetId;
        this.showWidget();
      }
    } else if (data && data.error) {
      this.setRootMessage(data);
    }
  }
  getAllValue() {
    let data = [];
    let uniqBlockIds = [];
    this.blockIds.forEach(blockId => {
      if (!uniqBlockIds.find(elem => elem.id === blockId.id)) {
        uniqBlockIds.push(blockId);
      }
    });
    this.blockIds = [...uniqBlockIds];
    this.blockIds.forEach((id, index) => {
      let fields = [];
      let blockIds = [];
      for (let i = 0; i < index + 1; i++) {
        blockIds.push(this.blockIds[i].id);
      }
      this.components[id.id].forEach(component => {
        if (component.getValue) {
          let dataField = component.getValue();
          if (dataField) {
            fields.push(dataField);
          }
        }
      });
      data.push({
        fields: fields,
        blockId: id.id,
        blockIds: blockIds,
        formId: this.id,
        domain: this.domain
      });
    });
    return data;
  }
  sendForm() {
    let captchaToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    this.sendFlag = true;
    this.Emitter.emit("Submit:disabledBtn", true);
    this.Emitter.emit("Submit:loading", true);
    this.completeBlockIds.push(this.blockIds[this.blockIds.length - 1]);
    let data;
    let proxyData = this.Proxy.getData();
    data = {
      ...proxyData
    };
    data.gRecaptchaResponse = captchaToken ? captchaToken.token || "" : "";
    data.formId = this.id;
    data.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let crypt = new JSEncrypt();
    crypt.default_key_size = 515;
    crypt.setPublicKey(this.publicKey);
    let timeSTR = "" + Math.floor(new Date().getTime() / 1000);
    crypt.encrypt(timeSTR);
    data.verificationCode = crypt.encrypt(timeSTR);
    data.domain = this.domain;
    data.pageSource = location.pathname + location.search + location.hash;
    data.quizBlocks = JSON.stringify(this.getAllValue());
    data.fillTime = Math.round(new Date(Date.now() - this.endInitForm || 0) / 1000);
    data.userAgent = navigator.userAgent;
    data.os = navigator?.userAgentData?.platform || navigator?.platform || "unknown";
    data.deviceType = device.type();
    data.advAgreement = this.isAdviseCheckboxChecked;
    //отключение настройки видеовиджета для шага сообщения об успешной отправке формы
    if (this.settings.extraSettings?.noWidgets) {
      data.vw = "no";
    }
    this.Transporter.post(`https://${this.options.server_host}${this.options.send_quiz_controller}`, {
      body: data,
      options: {
        method: "POST",
        decode: false
      },
      callback: this.getResponse = this.getResponse.bind(this),
      callbackError: err => {
        if (err.readyState === 4) {
          const message = JSON.parse(err.response);
          this.setRootMessage({
            error: message.recaptcha || message.error
          });
        }
      }
    });
  }
  onloadCaptcha() {
    this.Emitter.emit("QForm:onloadCaptcha", {});
  }
  initFieldHook() {
    this.countInitComponents++;
    if (this.countInitComponents === this.components[this.settings.data.firstBlockId].length) {
      this.endInitForm = parseInt(new Date().getTime());
      this.emitterStatistics.emit(`${this.id}:fullTime`, {
        id: this.id,
        time: this.endInitForm
      });
      this.emitterStatistics.emit(`${this.id}:requestStatistic`, {
        id: this.id
      });
    }
  }
  async renderComponents(blockId) {
    this.rows = [];
    this.components[blockId] = this.components[blockId].map(x => {
      let $el;
      let isNewRow;
      if (x.options.row) {
        if (!this.rows.find(row => row.id === x.options.row)) {
          const newRow = {
            id: x.options.row,
            $el: this.$.create("div", "qform-row"),
            elementsCount: 1
          };
          this.rows.push(newRow);
          $el = newRow.$el;
          isNewRow = true;
        } else {
          const row = this.rows.find(row => row.id === x.options.row);
          $el = row.$el;
          row.elementsCount++;
          isNewRow = false;
        }
      } else {
        $el = this.$.create("div", "qform-row");
        isNewRow = true;
        this.rows.push({
          id: `single_row_${this.rows.length}`,
          $el
        });
      }
      const component = new x.Component($el, {
        ...x.options,
        allStyle: this.allStyle
      });
      $el.$el.insertAdjacentHTML("beforeend", component.toHTML());
      component.init();
      if (isNewRow) {
        this.$form.append($el);
      }
      this.$navBtn.$el.before($el.$el);
      return component;
    });
  }
  hideComponents(blockId) {
    this.components[blockId].forEach(component => {
      if (!this.hiddenComponents[blockId]) {
        this.hiddenComponents[blockId] = [];
      }
      if (component.hidden) {
        component.hidden();
        this.hiddenComponents[blockId].push(component);
      }
    });
  }
  showComponents(blockId) {
    this.hiddenComponents[blockId]?.forEach(component => {
      component.show();
    });
  }

  //обработка данных для полей следующего шага квиза
  setNextComponents() {
    return data => {
      let lastBlock = data.lastBlock === 1;
      this.currentBlockOrder = data.order;
      this.allOptions = data.options; // options for fields
      // настройки для изоражения формы
      this.quizPictureSrc = data.img_src;
      this.quizPicturePosition = data.img_position;
      this.quizPictureShowOnMobile = data.img_show_on_mobile;
      this.saveQuizPictureData(data.blockId);
      this.typeBlocks[data.blockId] = data.blockType;

      // let oldBlockId = this.blockIds[data.order]
      //   ? this.blockIds[data.order].id
      //   : false;

      this.blockTitle[data.blockId] = data.blockTitle || "";
      this.fields = data.fields;

      // if (oldBlockId) {
      //   if (oldBlockId === 0) {
      //     if (this.typeBlocks[oldBlockId] === data.blockType) {
      //       // console.log(
      //       //   `Старый: {тип: 0, id: ${oldBlockId}}, Новый: {тип: ${data.blockType}, id: ${data.blockId}} => установить старый`
      //       // );
      //       // оставить старый
      //       // this.currentBlockId = oldBlockId;
      //       this.setOldStep(lastBlock);
      //     } else {
      //       // console.log(
      //       //   `Старый: {тип: 0, id: ${oldBlockId}}, Новый: {тип: ${data.blockType}, id: ${data.blockId}} => установить новый`
      //       // );
      //       // установить новый
      //       this.setNewStep(data.blockId, lastBlock);
      //     }
      //   } else {
      //     if (
      //       this.blockIds[this.currentBlockOrder] &&
      //       this.blockIds[this.currentBlockOrder] === data.blockId
      //     ) {
      //       // оставить старый
      //       // console.log(
      //       //   `Старый: {тип: 2, id: ${oldBlockId}}, Новый: {тип: ${data.blockType}, id: ${data.blockId}} => установить старый`
      //       // );
      //       // this.currentBlockId = oldBlockId;
      //       this.setOldStep(lastBlock);
      //     } else {
      //       // console.log(
      //       //   `Старый: {тип: 2, id: ${oldBlockId}}, Новый: {тип: ${data.blockType}, id: ${data.blockId}} => установить новый`
      //       // );
      //       // установить новый
      //       this.setNewStep(data.blockId, lastBlock);
      //     }
      //   }
      // } else {
      this.setNewStep(data.blockId, lastBlock, {
        widgetId: data.videowidgetId
      });
      // }
    };
  }

  //отрисовка следующего блока квиза
  async setNewStep(blockId) {
    let lastBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let {
      widgetId
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    this.hideComponents(this.blockIds[this.blockIds.length - 1].id);
    // this.blockIds[this.currentBlockOrder] = blockId;
    this.blockIds.push({
      id: blockId,
      order: this.currentBlockOrder
    });
    if (!this.hiddenComponents[blockId]) {
      await this.getComponent(blockId, lastBlock);
      await this.renderComponents(blockId);
    } else {
      this.showComponents(blockId);
    }
    this.preventClearQuizBg();
    this.addQuizPicture();

    // Применение options
    this.getOptions(this.arrComponetsOptions, blockId);
    this.Emitter.emit("setNextTab", this.blockIds, blockId, this.blockTitle[blockId], false, this.currentBlockOrder);
    let endTab = false;
    if (lastBlock) {
      endTab = true;
    }
    // console.log(this.blockIds.length);
    this.Emitter.emit("setNavBtn", this.blockIds.length - 1, endTab);
    this.currentBlockId = blockId;
    this.setQformRowsIds();
    if (!this.sendFlag) {
      this.setStyle();
    }
    this.setQuizPictureHeight();
    this.Emitter.emit("setQuizViewPosition", this.$form.$el);
    this.setNavButtonsActivity();
    this.Emitter.emit("Submit:disabledBtn", false);
    this.Emitter.emit("nextBtnLoadingEnd");
    if (widgetId && this.widgetId !== widgetId) {
      if (!window.players?.[this.widgetId]?.isDisposed()) {
        window.players?.[this.widgetId]?.dispose();
      }
      this.widgetId = widgetId;
      this.showWidget();
    }
    this.blocksWidgetsIds[this.currentBlockId] = this.widgetId;
    this.emitterFormWidget.emit(`block_${blockId}_build`);
    this.dispatchCustomEvent(`step_${this.currentBlockOrder}_build`);
  }
  setOldStep() {
    let lastBlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.Emitter.emit("Submit:disabledBtn", true);
    this.hideComponents(this.blockIds[this.blockIds.length - 1].id);
    this.blockIds.pop();
    // this.stepCount--;
    this.currentBlockId = this.blockIds[this.blockIds.length - 1].id;
    this.currentBlockOrder = this.blockIds[this.blockIds.length - 1].order;
    this.showComponents(this.currentBlockId);

    //загружаем настройки картинки квиза по id блока, на который произошел возврат
    this.quizPictureSrc = this.quizPicturesData[this.currentBlockId].quizPictureSrc;
    this.quizPicturePosition = this.quizPicturesData[this.currentBlockId].quizPicturePosition;
    this.quizPictureShowOnMobile = this.quizPicturesData[this.currentBlockId].quizPictureShowOnMobile;
    this.preventClearQuizBg();
    this.addQuizPicture();
    this.setQuizPictureHeight();
    this.Emitter.emit("setQuizViewPosition", this.$form.$el);
    let endTab = false;
    if (lastBlock) {
      endTab = true;
    }
    this.Emitter.emit("setNextTab", this.blockIds,
    // this.blockIds[this.currentBlockOrder].id,
    this.currentBlockId, this.blockTitle[this.currentBlockId], endTab, this.currentBlockOrder);
    this.Emitter.emit("setNavBtn", this.blockIds.findIndex(id => id.id === this.currentBlockId), endTab);
    this.Emitter.emit("Submit:disabledBtn", false);
    this.setNavButtonsActivity();
    this.Emitter.emit("prevBtnLoadingEnd");
    if (this.blocksWidgetsIds[this.currentBlockId] && this.widgetId !== this.blocksWidgetsIds[this.currentBlockId]) {
      if (!window.players?.[this.widgetId]?.isDisposed()) {
        window.players?.[this.widgetId]?.dispose();
      }
      this.widgetId = this.blocksWidgetsIds[this.currentBlockId];
      this.showWidget();
    }
    this.emitterFormWidget.emit(`block_${this.currentBlockId}_build`);
    this.dispatchCustomEvent(`step_${this.currentBlockOrder}_build`);
  }

  //функция переключения на следующую вкладку
  nextTab() {
    this.Emitter.emit("Submit:disabledBtn", true);
    //готовим текущий блок для отправки на сервер,чтобы сохранить его и получить новый
    let data = {};
    data.formId = this.id;
    data.domain = this.domain || "app.qform.io";
    data.blockId = this.currentBlockId;
    this.completeBlockIds.push(this.currentBlockId);
    let blockIds = [];
    for (let i = 0; i < this.blockIds.length; i++) {
      blockIds.push(this.blockIds[i].id);
    }
    data.blockIds = JSON.stringify(blockIds);
    data.timezone = this.settings.options.timezone;
    let fields = [];
    this.components[this.currentBlockId].forEach(component => {
      if (component.getValue) {
        let dataField = component.getValue();
        if (dataField) {
          fields.push(dataField);
        }
      }
    });
    data.fields = JSON.stringify(fields);
    //отключение настройки видеовиджета у следующего шага
    if (this.settings.extraSettings?.noWidgets) {
      data.vw = "no";
    }
    //отправка текущего блока квиза на сервер
    //в ответ - данные для следующего блока
    this.Transporter.post(`https://${this.options.server_host}${this.options.next_controller}`, {
      body: data,
      options: {
        method: "POST",
        decode: false
      },
      callback: this.setNextComponents()
    });
  }

  /**
   * функция для простановки идентификаторов для строк формы
   */
  setQformRowsIds() {
    this.rows.forEach((row, i) => {
      row.$el.$el.id = `qform-row_${this.id}_${i + 1}_step${this.currentBlockOrder + 1}`;
    });
  }

  //получение настроек стилей
  getStyle() {
    if (!this.allStyle) {
      this.Transporter.post(`https://${this.options.server_host}${this.options.style_controller}`, {
        body: {
          formId: this.id
        },
        options: {
          method: "POST",
          decode: false
        },
        callback: this.setStyle = this.setStyle.bind(this)
      });
    } else {
      this.setStyle(this.allStyle);
    }
  }

  //применение стилей
  setStyle() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (data) {
      this.fieldStyle = data;
      this.components[this.currentBlockId].forEach(component => {
        if (component.setClassField && data) {
          component.setClassField(data);
        }
      });
      if (this.navTop.setClassField && data) {
        this.navTop.setClassField(data);
      }
      if (this.navBtn) {
        this.navBtn.setClassField(data);
      }
    } else {
      this.components[this.currentBlockId].forEach(component => {
        if (component.setClassField && this.fieldStyle) {
          component.setClassField(this.fieldStyle);
        }
      });
    }
    this.setHintStyles();
    if (this.rows.length) {
      this.rows.forEach(row => {
        if (row.elementsCount > 1) {
          const root = row.$el.$el;
          root.classList.add(`multiple-cols-${row.elementsCount}`);
          for (let i = 0; i < root.children.length; i++) {
            root.children[i].classList.add("multiple-col");
          }
        }
      });
    }
    if (this.btnModalComponent && this.btnModalComponent.setClassField && data) {
      this.btnModalComponent.setClassField(data);
    }
    if (data) {
      this.$form.$el.setAttribute("class", "qform");
    }
    if (data && data.formStyleCommon && data.formStyleCommon.useDesign) {
      // Стиль формы
      if (data.formStyleCommon && typeof data.formStyleCommon.fieldStyle !== "undefined" && FORM_STYLE[data.formStyleCommon.fieldStyle]) {
        this.$form.$el.classList.add(FORM_STYLE[data.formStyleCommon.fieldStyle]);
      }

      // Темная тема формы
      if (data.formStyleCommon && data.formStyleCommon.theme) {
        this.$form.$el.classList.add("qform-theme-black");
      }
      // Состояние полей
      // if (typeof data.formStyleFieldState !== "undefined") {
      //   let color = {
      //     0: "grey",
      //     1: "blue",
      //     2: "dark-blue",
      //     3: "black",
      //   };

      //   if (data.formStyleFieldState.changeColorOnHover) {
      //     this.$form.$el.classList.add(
      //       `qform-hover_${color[data.formStyleFieldState.colorOnHover]}`
      //     );
      //   } else {
      //     //оставляем дефолтный класс поля при наведении
      //     this.$form.$el.classList.add(`qform-hover_grey`);
      //   }

      //   if (data.formStyleFieldState.changeColorOnFocus) {
      //     this.$form.$el.classList.add(
      //       `qform-focus_${color[data.formStyleFieldState.colorOnFocus]}`
      //     );
      //   } else {
      //     //оставляем дефолтный класс поля при фокусе
      //     this.$form.$el.classList.add(`qform-focus_grey`);
      //   }

      //   if (!data.formStyleFieldState.useDesign) {
      //     this.$form.$el.classList.remove("qform-hover_grey");
      //     this.$form.$el.classList.remove("qform-hover_blue");
      //     this.$form.$el.classList.remove("qform-hover_dark-blue");
      //     this.$form.$el.classList.remove("qform-hover_black");

      //     this.$form.$el.classList.remove("qform-focus_grey");
      //     this.$form.$el.classList.remove("qform-focus_blue");
      //     this.$form.$el.classList.remove("qform-focus_dark-blue");
      //     this.$form.$el.classList.remove("qform-focus_black");
      //   }
      // }
      // Размер полей
      if (data.formStyleCommon && typeof data.formStyleCommon.fieldSize !== "undefined" && FIELD_SIZE[data.formStyleCommon.fieldSize]) {
        this.$form.$el.classList.add(FIELD_SIZE[data.formStyleCommon.fieldSize]);
      }
      // Border-radius полей
      if (data.formStyleCommon && typeof data.formStyleCommon.fieldRounding !== "undefined" && FIELD_RADIUS[data.formStyleCommon.fieldRounding]) {
        this.$form.$el.classList.add(FIELD_RADIUS[data.formStyleCommon.fieldRounding]);
      }
      // label
      if (data.formStyleLabel && typeof data.formStyleLabel.type !== "undefined") {
        if (data.formStyleLabel.type === 0) {
          if (typeof data.formStyleLabel.labelOutsidePosition !== "undefined" && data.formStyleLabel.labelOutsidePosition === 0) {
            this.$form.$el.classList.add("qform-label_outside_top");
          } else {
            this.$form.$el.classList.add("qform-label_outside_left");
          }
        } else {
          if (typeof data.formStyleLabel.labelInsideShowOnEnter !== "undefined" && data.formStyleLabel.labelInsideShowOnEnter === 0) {
            this.$form.$el.classList.add("qform-label_inside_hide");
          } else {
            this.$form.$el.classList.add("qform-label_inside_show");
          }
        }
        if (!data.formStyleLabel.useDesign) {
          this.$form.$el.classList.remove("qform-label_outside_top");
          this.$form.$el.classList.remove("qform-label_outside_left");
          this.$form.$el.classList.remove("qform-label_inside_hide");
          this.$form.$el.classList.remove("qform-label_inside_show");
        }
      }
      // placeholder
      if (data.formStyleLabel && !data.formStyleLabel.placeholderShow) {
        this.$form.$el.classList.add("qform-placeholder_hide");
      }
      // Icon
      if (data.formStyleIcon && typeof data.formStyleIcon.position !== "undefined") {
        if (data.formStyleIcon.position === 0) {
          if (typeof data.formStyleIcon.positionInside !== "undefined" && data.formStyleIcon.positionInside === 0) {
            this.$form.$el.classList.add("qform-icon_inside_left");
          } else {
            this.$form.$el.classList.add("qform-icon_inside_right");
          }
        } else {
          if (typeof data.formStyleIcon.positionOutside !== "undefined" && data.formStyleIcon.positionOutside === 0) {
            this.$form.$el.classList.add("qform-icon_outside_left");
          } else {
            this.$form.$el.classList.add("qform-icon_outside_right");
          }
        }
        if (!data.formStyleIcon.useDesign) {
          this.$form.$el.classList.remove("qform-icon_inside_left");
          this.$form.$el.classList.remove("qform-icon_inside_right");
          this.$form.$el.classList.remove("qform-icon_outside_left");
          this.$form.$el.classList.remove("qform-icon_outside_right");
        }
      }
      // Hint
      if (data.formStyleHelp && typeof data.formStyleHelp.position !== "undefined") {
        if (data.formStyleHelp.position === 0) {
          this.$form.$el.classList.add("qform-hint_label");
        } else if (data.formStyleHelp.position === 1) {
          this.$form.$el.classList.add("qform-hint_inside-left");
        } else if (data.formStyleHelp.position === 2) {
          this.$form.$el.classList.add("qform-hint_inside-right");
        } else if (data.formStyleHelp.position === 3) {
          this.$form.$el.classList.add("qform-hint_outside-left");
        } else if (data.formStyleHelp.position === 4) {
          this.$form.$el.classList.add("qform-hint_outside-right");
        } else if (data.formStyleHelp.position === 5) {
          this.$form.$el.classList.add("qform-hint_bottom");
        }
        if (!data.formStyleHelp.useDesign) {
          this.$form.$el.classList.remove("qform-hint_label");
          this.$form.$el.classList.remove("qform-hint_inside-left");
          this.$form.$el.classList.remove("qform-hint_inside-right");
          this.$form.$el.classList.remove("qform-hint_outside-left");
          this.$form.$el.classList.remove("qform-hint_outside-right");
          this.$form.$el.classList.remove("qform-hint_bottom");
        }
      }
      // Valid
      if (data.formStyleValidationSuccess && typeof data.formStyleValidationSuccess.type !== "undefined") {
        if (data.formStyleValidationSuccess.type === 0) {
          if (typeof data.formStyleValidationSuccess.iconAsideLabelPosition !== "undefined" && data.formStyleValidationSuccess.iconAsideLabelPosition === 0) {
            this.$form.$el.classList.add("qform-valid_inside-left");
          } else {
            this.$form.$el.classList.add("qform-valid_inside-right");
          }
        } else if (data.formStyleValidationSuccess.type === 1) {
          if (typeof data.formStyleValidationSuccess.iconOutsideInputPosition !== "undefined" && data.formStyleValidationSuccess.iconOutsideInputPosition === 0) {
            this.$form.$el.classList.add("qform-valid_outside-left");
          } else {
            this.$form.$el.classList.add("qform-valid_outside-right");
          }
        } else if (data.formStyleValidationSuccess.type === 2) {
          this.$form.$el.classList.add("qform-valid_label");
        } else if (data.formStyleValidationSuccess.type === 3) {
          this.$form.$el.classList.add("qform-valid_light");
        }
        if (!data.formStyleValidationSuccess.useDesign) {
          this.$form.$el.classList.remove("qform-valid_inside-left");
          this.$form.$el.classList.remove("qform-valid_inside-right");
          this.$form.$el.classList.remove("qform-valid_outside-left");
          this.$form.$el.classList.remove("qform-valid_outside-right");
          this.$form.$el.classList.remove("qform-valid_label");
          this.$form.$el.classList.remove("qform-valid_light");
        }
      }
      // Error
      if (data.formStyleError && typeof data.formStyleError.type !== "undefined") {
        if (data.formStyleError.type === 0) {
          if (typeof data.formStyleError.iconPositionInsideInput !== "undefined" && data.formStyleError.iconPositionInsideInput === 0) {
            this.$form.$el.classList.add("qform-error_inside-left");
          } else {
            this.$form.$el.classList.add("qform-error_inside-right");
          }
        } else if (data.formStyleError.type === 1) {
          if (typeof data.formStyleError.iconPositionOutsideInput !== "undefined" && data.formStyleError.iconPositionOutsideInput === 0) {
            this.$form.$el.classList.add("qform-error_outside-left");
          } else {
            this.$form.$el.classList.add("qform-error_outside-right");
          }
        } else if (data.formStyleError.type === 2) {
          this.$form.$el.classList.add("qform-error_label");
        } else if (data.formStyleError.type === 3) {
          this.$form.$el.classList.add("qform-error_light");
        }
        if (!data.formStyleError.useDesign) {
          this.$form.$el.classList.remove("qform-error_inside-left");
          this.$form.$el.classList.remove("qform-error_inside-right");
          this.$form.$el.classList.remove("qform-error_outside-left");
          this.$form.$el.classList.remove("qform-error_outside-right");
          this.$form.$el.classList.remove("qform-error_label");
          this.$form.$el.classList.remove("qform-error_light");
        }
      }
    }
  }
  setHintStyles() {
    const hintIcons = this.$form.$el.querySelectorAll(".qform-field_hint");
    for (let i = 0; i < hintIcons.length; i++) {
      const content = hintIcons[i].querySelector(".qform-field_hint_message > p");
      const message = hintIcons[i].querySelector(".qform-field_hint_message");
      hintIcons[i].addEventListener("mouseenter", () => {
        //если не хватает места между иконкой подсказки и верхней границей страницы для появления сообщения,
        //показываем его сбоку от значка
        const hintCoords = hintIcons[i].getBoundingClientRect();
        if (hintCoords.top < content.clientHeight + 5) {
          hintIcons[i].classList.add("qform-hint__under-sign");
        } else {
          hintIcons[i].classList.remove("qform-hint__under-sign");
        }
        if (document.documentElement.clientWidth - hintCoords.right < content.clientWidth + 5) {
          if (hintCoords.left < content.clientWidth + 5) {
            hintIcons[i].classList.add("qform-hint__centered");
          } else {
            hintIcons[i].classList.add("qform-hint__reverted");
          }
        } else {
          hintIcons[i].classList.remove("qform-hint__reverted");
          hintIcons[i].classList.remove("qform-hint__centered");
        }
        message.style.height = content.clientHeight + "px";
        message.style["box-shadow"] = "0px 0px 4px 0px #828282";
      });
      hintIcons[i].addEventListener("mouseleave", () => {
        message.style.removeProperty("height");
        message.style.removeProperty("box-shadow");
      });
    }
  }
  setGoogleFont() {
    if (this.useDesign) {
      this.fontCssRule = this.allStyle.formStyleText.font ? `'${this.allStyle.formStyleText.font.name}', sans-serif` : "inherit";
      this.$form.$el.style.fontFamily = this.fontCssRule;
      this.$navHere.$el.style.fontFamily = this.fontCssRule;
      //если форма в модальном окне
      if (this.quizDisplayType === 1) {
        this.$btnModal.$el.style.fontFamily = this.fontCssRule;
      }
    }
  }

  //получение настроек для полей
  getOptions(arrComponentsOptions, blockId) {
    if (!this.allOptions) {
      if (arrComponentsOptions.length > 0) {
        this.Transporter.post(`https://${this.options.server_host}${this.options.options_controller}`, {
          body: {
            domain: this.options.domain,
            formId: this.id,
            fields: JSON.stringify(arrComponetsOptions)
          },
          options: {
            method: "POST",
            decode: false
          },
          callback: this.setOptions(blockId)
        });
      }
    } else {
      let setOptions = this.setOptions(blockId);
      setOptions(this.allOptions);
    }
  }

  //применение настроек к полям текущей вкладки
  setOptions(blockId) {
    return data => {
      this.components[blockId].forEach(component => {
        if (typeof component.setOption === "function") {
          if (data[component.typeId]) {
            const fieldId = component.options.id;
            component.setOption(data[component.typeId].filter(o => o.formFieldId === fieldId));
          }
        }
      });
    };
  }
  checkCurrentComponentsValid() {
    let showErrorMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let valid = true;
    this.components[this.currentBlockId].forEach(component => {
      if (component.validation && !component.validation(showErrorMessages)) {
        valid = false;
      }
    });
    return valid;
  }

  //валидация полей текущей вкладки при переходе на следующий шаг
  validCurrentForm() {
    if (this.checkCurrentComponentsValid(true)) {
      this.Emitter.emit("nextBtnLoading");
      this.nextTab();
    }
  }
  setNavButtonsActivity() {
    this.Emitter.emit("Submit:addDisabledStyleBtn", !this.checkCurrentComponentsValid());
  }

  //валидация всего квиза перед отправкой
  validAllForm() {
    let valid = true;
    this.components[this.currentBlockId].forEach(component => {
      if (component.validation && !component.validation()) {
        valid = false;
      }
    });
    if (this.useRecaptcha === 1 && valid) {
      this.Emitter.emit("QForm:captchaShow", {});
    } else if (this.useRecaptcha === 0 && valid) {
      this.Emitter.emit("Submit:sendForm", {});
    }
  }
  async loadModule() {
    this.Transporter = await import( /* webpackChunkName: "transporter" */"../core/transporter").then(data => {
      return data.transporter;
    });
    this.$ = await import( /* webpackChunkName: "dom" */"../core/dom").then(data => {
      return data.$;
    });
    const Emitter = await import( /* webpackChunkName: "Emitter" */"../core/Emitter").then(data => {
      return data.Emitter;
    });
    if (this.quizDisplayType === 1) {
      this.BtnModalComponent = await import( /* webpackChunkName: "BtnModalComponent" */"../components/btnModal/btnModal.component").then(data => {
        return data.BtnModalComponent;
      });
    }
    this.$el = this.$(this.selector);
    this.Emitter = new Emitter();
  }
  async getInstanceComponent(arrFieldId) {
    let instaceList = {
      3: async () => {
        return await import( /* webpackChunkName: "CheckboxComponent" */"../components/inputCheckbox/Checkbox.component").then(data => {
          return data.CheckboxComponent;
        });
      },
      4: async () => {
        return await import( /* webpackChunkName: "DateComponent" */"../components/inputDate/Date.component").then(data => {
          return data.DateComponent;
        });
      },
      5: async () => {
        return await import( /* webpackChunkName: "FileComponent" */"../components/inputFile/File.component").then(data => {
          return data.FileComponent;
        });
      },
      8: async () => {
        return await import( /* webpackChunkName: "RadioComponent" */"../components/inputRadio/Radio.component").then(data => {
          return data.RadioComponent;
        });
      },
      9: async () => {
        return await import( /* webpackChunkName: "SelectComponent" */"../components/inputSelect/Select.component").then(data => {
          return data.SelectComponent;
        });
      },
      11: async () => {
        return await import( /* webpackChunkName: "TextareaComponent" */"../components/inputTextarea/Textarea.component").then(data => {
          return data.TextareaComponent;
        });
      },
      12: async () => {
        return await import( /* webpackChunkName: "UniversalComponent" */"../components/inputUniversal/Universal.component").then(data => {
          return data.UniversalComponent;
        });
      },
      13: async () => {
        return await import( /* webpackChunkName: "TimeComponent" */"../components/inputTime/Time.component").then(data => {
          return data.TimeComponent;
        });
      },
      14: async () => {
        return await import( /* webpackChunkName: "SubmitComponent" */"../components/agreementCheck/Agreement.component").then(data => {
          return data.AgreementComponent;
        });
      },
      15: async () => {
        return await import( /* webpackChunkName: "UniversalComponent" */"../components/inputUniversal/Universal.component").then(data => {
          return data.UniversalComponent;
        });
      },
      16: async () => {
        return await import( /* webpackChunkName: "BoxTextComponent" */"../components/boxText/BoxText.component").then(data => {
          return data.BoxTextComponent;
        });
      },
      17: async () => {
        return await import( /* webpackChunkName: "HiddenComponent" */"../components/inputHidden/Hidden.component").then(data => {
          return data.HiddenComponent;
        });
      },
      18: async () => {
        return await import( /* webpackChunkName: "UniversalComponent" */"../components/inputUniversal/Universal.component").then(data => {
          return data.UniversalComponent;
        });
      },
      19: async () => {
        return await import( /* webpackChunkName: "UniversalComponent" */"../components/inputUniversal/Universal.component").then(data => {
          return data.UniversalComponent;
        });
      },
      20: async () => {
        return await import( /* webpackChunkName: "BoxImage" */"../components/boxImage/BoxImage.component").then(data => {
          return data.BoxImage;
        });
      },
      22: async () => {
        return await import("../components/randomField/Random.component").then(data => {
          return data.Random;
        });
      },
      24: async () => {
        return await import("../components/galleryVideo/VideoGallery.component").then(data => {
          return data.VideoGalleryComponent;
        });
      },
      25: async () => {
        return await import( /* webpackChunkName: "PhotoGalleryComponent" */"../components/galleryPhoto/PhotoGallery.component").then(data => {
          return data.PhotoGalleryComponent;
        });
      },
      26: async () => {
        return await import("../components/linkField/Link.component").then(data => {
          return data.LinkComponent;
        });
      },
      CaptchaComponent: async () => {
        return await import( /* webpackChunkName: "CaptchaComponent" */"../components/captchaBox/Captcha.component").then(data => {
          return data.CaptchaComponent;
        });
      },
      7: async () => {
        return await import("../components/RatingField/RatingField.component").then(c => c.RatingFieldComponent);
      }
    };
    let instace = {};
    for (let i = 0; i < arrFieldId.length; i++) {
      if (instaceList[arrFieldId[i]]) {
        instace[arrFieldId[i]] = await instaceList[arrFieldId[i]]();
      }
    }
    instace[14] = await instaceList[14]();
    instace.CaptchaComponent = await instaceList.CaptchaComponent();
    return instace;
  }

  //остаток функционала от квиза в виджете
  emitStep(_, current, __, ___) {
    this.EmitterChangeStep.emit("ChangeStep", {
      formId: this.id,
      currentBlockId: current
    });
  }

  //установка ширины квиза
  setQuizWidth() {
    let el = this.quizDisplayType === 1 ? this.$modal.$el : this.$el.$el;
    //если квиз в контенте
    if (this.quizDisplayType === 0) {
      if (Number(this.data.width) === 0) {
        el.style.width = "auto";
        el.style.maxWidth = "100%";
        el.style.boxSizing = "border-box";
      } else {
        el.style.width = `${this.data.width}px`;
        el.style.maxWidth = "100%";
        el.style.margin = "0 auto";
        el.style.boxSizing = "border-box";
      }
      //если квиз в модальном окне
    } else {
      if (Number(this.data.width) === 0) {
        el.style.width = "auto";
        el.style.maxWidth = "100%";
        el.style.boxSizing = "border-box";
      } else {
        el.style.width = `${this.data.width}px`;
        el.style.maxWidth = "calc(100vw - 40px)";
        el.style.margin = "20px auto";
        el.style.boxSizing = "border-box";
      }
      //в выражении calc(100vw - 40px) 40px - это 20px * 2 - боковые маржины модального окна
    }
  }

  dispatchCustomEvent(eventName) {
    const initEvent = new Event(`qform_${this.id}_${eventName}`);
    this.$el.$el.dispatchEvent(initEvent);
  }

  //рендеринг квиза
  async render() {
    await this.loadModule();
    await this.getComponent(this.firstBlockId);
    this.Emitter.subscribe("nextTab", this.validCurrentForm.bind(this));
    this.Emitter.subscribe("prevTab", () => this.setOldStep(false));
    this.Emitter.subscribe("Submit:validForm", this.validAllForm.bind(this));
    this.Emitter.subscribe("Submit:sendForm", this.sendForm.bind(this));
    this.Emitter.subscribe("Change:field", this.setNavButtonsActivity.bind(this));
    this.Emitter.subscribe("adviseCheckboxChanged", checked => this.isAdviseCheckboxChecked = checked);
    //проверить на deprecated
    if (this.EmitterChangeStep) {
      this.Emitter.subscribe("setNextTab", this.emitStep.bind(this));
    }
    this.Emitter.subscribe("initField", this.initFieldHook.bind(this));
    this.startTimeRender = parseInt(new Date().getTime());

    //создаем обертку для помещения в нее квиза и возможности добавить изображения
    this.$quizFormWrapper = this.$.create("div", "qform__quiz-wrapper");
    this.$quizFormWrapper.$el.setAttribute("id", this.quizWrapperId);
    this.$quizFormWrapper.append(await this.getRoot());
    this.$quizFormWrapper.$el.prepend(this.getTabnav());
    this.widgetId = this.data.videowidgetId;
    this.blocksWidgetsIds[this.currentBlockId] = this.widgetId;
    //показываем видеовиджет, если он указан
    // if (this.widgetId && this.quizDisplayType === 0) {
    //   window.players?.[this.widgetId]?.dispose();
    //   this.showWidget()
    // }
    this.$el.clear();
    if (this.quizDisplayType === 1) {
      this.$el.append(this.createModal(this.$quizFormWrapper));
      this.btnModalComponent.init();
    } else {
      this.$el.append(this.$quizFormWrapper);
    }
    this.setGoogleFont();
    this.addQuizPicture();
    this.setQuizWidth();
    this.endTimeRender = parseInt(new Date().getTime());
    this.emitterStatistics.emit(`${this.id}:buildTime`, {
      id: this.id,
      time: this.endTimeRender - this.startTimeRender
    });
    this.startInitForm = parseInt(new Date().getTime());
    this.components[this.blockIds[0].id].forEach(component => component.init());
    // применение options
    this.getOptions(this.arrComponetsOptions, this.firstBlockId);
    // применение стилей css

    this.setQformRowsIds();
    if (this.useDesign) {
      this.getStyle();
    } else {
      this.$form.$el.classList.remove(...this.$form.$el.classList);
    }
    // применение options и масок для полей ввода
    if (this.quizDisplayType === 0) {
      this.setQuizPictureHeight();
    }

    //убираем прелоадеры
    const preloaders = document.querySelectorAll(`#${this.id}_loader_root`);
    for (let i = 0; i < preloaders.length; i++) {
      preloaders[i]?.remove();
    }
    this.navTop.init();
    this.setNavButtonsActivity();
    this.emitterFormWidget.emit(`block_${this.firstBlockId}_build`);
    this.dispatchCustomEvent("init");
  }
  destroy() {
    this.components[0].forEach(component => component.destroy());
  }
  async showWidget() {
    const widgetsGenerator = await import("./videoWidgetsGenerator.js").then(module => new module.videoWidgetsGenerator(this.options, this.domain, this.device, this.startTime));
    await widgetsGenerator.init();
    widgetsGenerator.formDisplayType = this.quizDisplayType;

    //закрываем все виджеты, не принадлежащие форме, кроме тех, которые имеют тип отображения в теле страницы,
    widgetsGenerator.freeWidgets?.forEach(widget => {
      if (widget.stylePreview !== 1) {
        widget.closeWidget({
          forcedClose: true
        });
        try {
          if (!window.players[widget.id].isDisposed()) {
            window.players[widget.id].dispose();
          }
        } catch (e) {

        }
      }
    });
    if (!document.querySelector(`div[data-widget=${this.widgetId}]`)) {
      const widgetNode = document.createElement("div");
      widgetNode.setAttribute("data-widget", this.widgetId);
      document.body.append(widgetNode);
    }
    await widgetsGenerator._renderWidgets([this.widgetId]);
  }
}